import { useCallback, useEffect, useState } from 'react';
export const useOnDelayedHover = (onHover, delay = 100) => {
  const [isActiveId, setIsActiveId] = useState(null);
  useEffect(() => {
    if (isActiveId) {
      const timeoutId = setTimeout(() => {
        onHover(isActiveId);
      }, delay);
      return () => clearTimeout(timeoutId);
    }
  }, [isActiveId, onHover, delay]);
  const onMouseEnter = useCallback(e => {
    setIsActiveId(e.currentTarget.id);
  }, []);
  const onMouseLeave = useCallback(() => {
    setIsActiveId(null);
  }, []);
  const onFocus = useCallback(e => {
    setIsActiveId(e.currentTarget.id);
  }, []);
  const onBlur = useCallback(() => {
    setIsActiveId(null);
  }, []);
  return {
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur
  };
};